const isOfType = <T extends { _type: GatsbyTypes.Maybe<string> }>(
  item: T | undefined | null,
  itemTypeName: string
): boolean => !!item && item._type === itemTypeName;

export default isOfType;
